import { Box, Stack, styled } from "@mui/material";
import { customColors } from "models/customColors";

export const Info = styled(Stack)`
  padding: 16px;
  border-radius: 13px;
  background-color: ${customColors.info.background};
`;

export const Property = styled(Stack)`
  flex-direction: row;
  gap: 0.35em;
  font-family: "Inter";
  font-size: 16px;
  color: ${customColors.info.text};
  text-align: left;
`;

export const Label = styled(Stack)`
  color: ${customColors.info.label};
`;

export const Title = styled(Box)`
  color: ${customColors.black};

  font-family: Inter;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
